import React from 'react'
import { ThemeProvider } from './context/ThemeContext'
import ThemeToggle from './components/theme/ThemeToggle'
import ScrollReveal from './components/scroll/ScrollReveal'
import Header from './components/header/header'
import Nav from './components/nav/nav'
import About from './components/about/about'
import Experience from './components/experience/experience'
import Services from './components/services/services';
import Portfolio from './components/portfolio/portfolio'
import Testimonials from './components/testimonial/testimonial'
import Contact from './components/contact/contact'
import Footer from './components/footer/footer'



const App = () => {
  return (
    <ThemeProvider>
        <ThemeToggle />
        <ScrollReveal rootMargin='0px 0px 0px 0px' threshold={0.08}>
          <Header />
        </ScrollReveal>
        <Nav />
        <ScrollReveal>
          <About />
        </ScrollReveal>
        <ScrollReveal>
          <Experience />
        </ScrollReveal>
        <ScrollReveal>
          <Services />
        </ScrollReveal>
        <ScrollReveal>
          <Portfolio />
        </ScrollReveal>
        <ScrollReveal>
          <Testimonials />
        </ScrollReveal>
        <ScrollReveal>
          <Contact />
        </ScrollReveal>
        <ScrollReveal>
          <Footer />
        </ScrollReveal>
    </ThemeProvider>
  )
}

export default App
